import { render, staticRenderFns } from "./order-push-search.vue?vue&type=template&id=55c52400&"
import script from "./order-push-search.vue?vue&type=script&lang=js&"
export * from "./order-push-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports